import { useMemo } from 'react'
import { useDebtStore, useNotificationStore } from '@/store'
import { buildPromoAlerts } from '@/engine/promoWatcher'
import type { PromoAlert } from '@/types'

export interface PromoAlertsResult {
  /** All alerts derived from current debts (includes dismissed ones) */
  all: PromoAlert[]
  /** Alerts the user hasn't dismissed (for the banner) */
  active: PromoAlert[]
  /** Alerts the user has dismissed (for the history panel) */
  dismissed: PromoAlert[]
  /** Critical or expired AND not dismissed — these get the prominent banner */
  banner: PromoAlert[]
}

export function usePromoAlerts(): PromoAlertsResult {
  const debts = useDebtStore((s) => s.debts)
  const dismissedMap = useNotificationStore((s) => s.dismissed)

  return useMemo(() => {
    const all = buildPromoAlerts(debts)
    const active: PromoAlert[] = []
    const dismissed: PromoAlert[] = []

    for (const alert of all) {
      if (alert.id in dismissedMap) {
        dismissed.push(alert)
      } else {
        active.push(alert)
      }
    }

    const banner = active.filter((a) => a.severity === 'expired' || a.severity === 'critical')

    return { all, active, dismissed, banner }
  }, [debts, dismissedMap])
}
